module.exports = __webpack_public_path__ + "img/jerome-bertaux-tRkBF9Ujqw4-unsplash.07c31423.jpg";